import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { startLoader, stopLoader } from "../util/loader";
import { getBrandDetailsFromBrandJson, getFranchiseWebLocationIdDetails, insertAfterUrl, storeBookingApiPayload } from "../util/share";
import { handleInputError } from "../util/commonValidation";
import { getBrandJSON } from "../util/locationBasedBrandJson";
import { gtmCustomEventLeadFlow } from "../util/gtm-custom-event-lead-flow";
import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { ContactUsPayloadModel } from "../apiCaching/POST-Requests/interface/contact/contactInterface";
import { DomainIdentifier } from "../util/domainService";
import { LocalizationIdentifier } from "../util/localizationService";
import { disclaimerHandleCheck, DisclaimerServiceIdentifier } from "../util/disclaimerService";
import { hideTermsPolicy, toggleTermsPolicyBasedOnCountry } from "../util/hideTermsPolicy";
import { getCountryCode } from "../location-search-map/getCountryCode";


export class FormHandlerAskQuestion {
    private form: HTMLFormElement | null = null;
    private readonly askQuestionFormService!: NodeListOf<HTMLElement>;

    private  nameInput: HTMLInputElement;
    private  lastInput: HTMLInputElement;
    private  phoneNumberInput: HTMLInputElement;
    private  emailInput: HTMLInputElement;
    private  zipCodeInput: HTMLInputElement;
    private commentTextInput: HTMLInputElement;
    private businessNameTextInput: HTMLInputElement;
    private errorMessage: { businessErrorName: string };

    private validateNotes: boolean = false;
    private validateBusiness: boolean = false;
    private noteWithRequestBody: any;


    constructor() {
        this.init();
        this.clearFields();
        const parentElement = document.querySelector('.contact-info.ask-question') as HTMLFormElement;
        this.nameInput = parentElement?.querySelector('#send-name') as HTMLInputElement;
        this.lastInput = parentElement?.querySelector('#sendL-name') as HTMLInputElement;
        this.phoneNumberInput = parentElement?.querySelector('#send-phone') as HTMLInputElement;
        this.emailInput = parentElement?.querySelector('#send-email') as HTMLInputElement;
        this.zipCodeInput = parentElement?.querySelector('#send-zip') as HTMLInputElement;
        this.commentTextInput = parentElement?.querySelector('#send-note') as HTMLInputElement;
        this.businessNameTextInput = parentElement?.querySelector('#business-name') as HTMLInputElement;
        this.phoneNumberInput = parentElement?.querySelector('#send-phone') as HTMLInputElement;
        if (this.phoneNumberInput) {
            this.phoneNumberInput.addEventListener('input', this.handleMobileInput.bind(this));
        }

        this.askQuestionFormService = document.querySelectorAll('[id*="ask-form-service-reminder"]');
        this.nameInput?.addEventListener('input', this.errorOnName.bind(this))
        this.lastInput?.addEventListener('input', this.errorOnLastName.bind(this))
        this.emailInput?.addEventListener('input', this.emailError.bind(this))
        this.zipCodeInput?.addEventListener('input', this.zipCodeError.bind(this))
        this.zipCodeInput?.addEventListener('focusout', this.handleFocusOut.bind(this));
        this.askQuestionFormService?.forEach((checkbox) => {
            checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
        });
        this.errorMessage = {
            businessErrorName: (document.getElementById('business-name-error-msg') as HTMLElement)?.textContent ?? 'Please enter the business name'
        }
        this.checkAndBindErrorFields();

    }

    handleFocusOut() {
        const zipCode = this.zipCodeInput?.value.trim();
        DisclaimerServiceIdentifier(zipCode);
        toggleTermsPolicyBasedOnCountry('#ask-question-form', zipCode);
    }
    handleCheckboxChange() {
        const forms = document.getElementById('ask-question-form');
        const serviceReminderDivs = forms?.querySelectorAll('.service-reminder-main');
        let errorID = null;
        // Check if any divs with the class 'service-reminder-main' are found
        if (!serviceReminderDivs || serviceReminderDivs.length === 0) {
            console.log('Servcie Disclaimer not authored in CP');
            return;
        }
        serviceReminderDivs.forEach((div: Element) => {
            // Check if the div is visible (does not have the 'hidden' class)
            if (div && !div.classList.contains('hidden')) {
                // Find the checkbox input inside this div
                const checkbox = div.querySelector('input[type="checkbox"]');
                // Find the corresponding error message element
                const errorMsg = div.querySelector('.error-msg');
                // Check if the checkbox and errorMsg exist and if the checkbox is required
                if (checkbox && errorMsg && checkbox instanceof HTMLInputElement && checkbox.required) {
                    // Add event listener to handle checkbox state change
                    checkbox.addEventListener('change', () => {
                        // If the checkbox is checked, hide the error message
                        if (checkbox.checked) {
                            errorMsg.classList.add('hidden');
                        } else {
                            // If the checkbox is unchecked, show the error message
                            errorMsg.classList.remove('hidden');
                            errorID = errorMsg?.id;
                        }
                    });
                    // Initial check: if the checkbox is required and unchecked when the page loads
                    if (checkbox.required && !checkbox.checked) {
                        errorMsg.classList.remove('hidden');
                        errorID = errorMsg?.id;
                    }
                }
            }
        });
        return errorID;
    }

    checkAndBindErrorFields() {
        if (this.commentTextInput) {
            if (this.commentTextInput.hasAttribute("required")) {
                this.commentTextInput?.addEventListener('input', this.errorOnComment.bind(this));
                this.validateNotes = true;
            }
        }
        if (this.businessNameTextInput) {
            if (this.businessNameTextInput.hasAttribute("required")) {
                this.businessNameTextInput?.addEventListener('input', this.errorOnInputFields.bind(this));
                this.validateBusiness = true;
            }
        }

    }

    errorOnName() {
        if (this.nameInput.value !== '' && !REGEX.sendName.test(this.nameInput.value)) {
            const getErrMsg = (document.getElementById(`send-name-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-name-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid name format.'

            }
            else {
                const field: any = this.nameInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg ?? 'Invalid name format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError('send-name')
        }

    }
    errorOnLastName() {
        if (this.lastInput.value !== '' && !REGEX.sendName.test(this.lastInput.value)) {
            const getErrMsg = (document.getElementById(`sendL-name-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`sendL-name-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid Last name format.';
            }
            else {
                const field: any = this.lastInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg ?? 'Invalid Last name format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError('sendL-name')
        }

    }
    emailError() {
        if (this.emailInput.value != '' && !REGEX.sendEmail.test(this.emailInput.value)) {
            const getErrMsg = (document.getElementById(`send-email-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-email-error-msg`);


            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid email address, please try again.'

            }
            else {
                const field: any = this.emailInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg ?? 'Invalid email address, please try again.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }


        }
        else {

            this.hideError('send-email')
        }

    }

    private handleMobileInput(e: Event): void {
        e.preventDefault();
        const reg = REGEX.mobileNumberRegex;
        const val = this.phoneNumberInput?.value;
        const phoneMatch = val?.replace(/\D/g, '').match(reg);
        let formattedVal = '';

        if (phoneMatch) {
            const areaCode = phoneMatch[1];
            const mainNumber = phoneMatch[2];
            const optionalDashWithPhoneNumbers = phoneMatch[3] ? '-' + phoneMatch[3] : '';

            formattedVal = `(${areaCode}) ${mainNumber}${optionalDashWithPhoneNumbers}`;
        }
        if (this.phoneNumberInput.value != '' && this.phoneNumberInput?.value.length < 14 && formattedVal.length < 14) {
            const getErrMsg = (document.getElementById(`send-phone-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-phone-error-msg`);


            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid phone format.'

            }
            else {
                const field: any = this.phoneNumberInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg ?? 'Invalid phone format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }


        }
        else {

            this.hideError.call(this, 'send-phone')
        }

        if (phoneMatch) {
            let formattedPhoneNumber;

            if (!phoneMatch[2]) {
                formattedPhoneNumber = phoneMatch[1];
            } else {
                formattedPhoneNumber = `(${phoneMatch[1]}) ${phoneMatch[2]}${phoneMatch[3] ? '-' + phoneMatch[3] : ''}`;
            }

            this.phoneNumberInput!.value = formattedPhoneNumber;
        }

    }

    zipCodeError() {
        if (this.zipCodeInput?.value != '' && !REGEX.sendZip.test(this.zipCodeInput?.value.trim())) {
            const getErrMsg = (document.getElementById(`send-zip-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-zip-error-msg`);


            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid zip code format.'
            }
            else {
                const field: any = this.zipCodeInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg ?? 'Invalid zip code format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }


        }
        else {

            this.hideError('send-zip')
        }

    }
    errorOnComment() {
        if (this.commentTextInput.value == '') {
            const getErrMsg = (document.getElementById(`send-note-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-note-error-msg`);
            if (fieldError) {
                this.commentTextInput?.classList.add('invalid-field')
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Enter a valid inputs'

            }
            else {
                const field: any = this.nameInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg ?? 'Enter a valid inputs.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError('send-note')
        }
    }

    errorOnInputFields() {
        handleInputError(this.businessNameTextInput, 'business-name-error-msg', REGEX.matchAny, this.errorMessage.businessErrorName);
    }

    hideError(id: any) {
        const field: any = document.getElementById(id);
        const fieldError: any = document.getElementById(`${id}-error-msg`);

        fieldError?.classList.add('hidden')
        field?.classList.remove('invalid-field')



    }

    clearFields = () => {
        const inputIds = [
            'send-state',
        ];
        //'send-note' field is removed from inputIds array as part of bug 242636
        inputIds.forEach((id) => {
            const input = document.getElementById(id) as HTMLInputElement;
            if (input) {
                input.addEventListener('input', () => {
                    input.classList.remove('invalid-field');
                    const errmsg = document.getElementById(`${id}-error-msg`);
                    if (errmsg) errmsg.remove();
                });
            }
        });
    };

    private init() {
        this.form = document.querySelector('#ask-question-form button') as HTMLFormElement;
        const radioElement = document.getElementById('inline-radio-6') as HTMLInputElement;

        if (this.form) {
            this.form.addEventListener('click', this.handleSubmit.bind(this));
            if (radioElement) radioElement.checked = true;
        }
        const localisation = DomainIdentifier();
        const countryCode = getCountryCode();
        const localisedcountryCode = sessionStorage.getItem('countryCode');
        if (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') {
            hideTermsPolicy('#ask-question-form', 'terms-policy-text');
        }
    }

    private async handleSubmit(event: Event): Promise<void> {
        event.preventDefault();
        const formFields = this.getFormFields();
        let host = window.location.hostname.toLowerCase();
        let IsTest;
        if (host.includes('nblysbx') || host.includes('nblydev') || host.includes('nblytest')) {
            IsTest = true;
        } else {
            IsTest = false;
        }
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        const url = window.location.origin;
        let vendorId;
        try {
            const brandJson = getBrandJSON();
            if (brandJson === 'Error validating Location') {
                console.error("Error Determining BrandJSON path for given location")
            }
            else {
                const apiResponse = await fetch(`${url}/${brandJson}`);
                const apiData = await apiResponse.json();

                const matchingVendor = apiData.find((item: any) => item.id === conceptId);
                if (matchingVendor) {
                    vendorId = matchingVendor.vendorId;
                }
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }

        if (this.validateForm()) {
            const labelElement = document.querySelector('label[for="business-name"].label-basic') as HTMLInputElement;
            const labelText = labelElement?.textContent?.trim();
            const businessNameWithoutAsterisk = labelText?.replace('*', '');
            const businessLableName = businessNameWithoutAsterisk ? ' ,' + businessNameWithoutAsterisk + ':' : '';
            const businessName = formFields.businessName ? ` ${businessLableName} ${formFields.businessName}` : '';
            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            let noteText ='';
            if(brandData.note_text_contactus_api?.length > 0) {
                noteText = brandData.note_text_contactus_api;
            }
           
            
            let requestBody: ContactUsPayloadModel = {
                comments: formFields.note + `${businessName} ${noteText}`,
                conceptId: Number(conceptId),
                email: formFields.email,
                firstName: formFields.firstName?.split(' ')[0],
                isLocalized: false,
                isNewCustomer: String(formFields.isSignup ?? false),
                isTest: IsTest,
                lastName: formFields.firstName?.split(' ')[1] ?? '',
                phone: formFields.phoneNumber,
                signUpForUpdates: this.checkForLatestUpdateRadio(),
                zipCode: formFields.zipCode?.trim(),
                vendorId: Number(vendorId),
            };
            try {

                if(this.lastInput) {
                    requestBody.lastName = this.lastInput?.value ?? ''; // If user have authored last name fied then we will pass otherwise we will split first name and take the last name from it.
                    requestBody.firstName = formFields?.firstName;
                }else{
                    const firstName = this.nameInput?.value.split(' ');
                    if(firstName.length > 1){   
                        requestBody.lastName = firstName.splice(-1).join(' ');
                        requestBody.firstName = firstName.join(' ');
                    }
                }
            
                const domain = DomainIdentifier();
                const localisation = LocalizationIdentifier();
                // Default value to pass if checkbox is not found
                let checkboxId = '';
                const countryZip = !REGEX.sendCaPostalCode.test(formFields.zipCode?.trim()) ? 'us' : 'ca';
                if (((domain === "us" && !localisation) || (domain === "us" && localisation=="us")) && countryZip === 'us') {
                    checkboxId = 'ask-form-service-reminder-us';
                } else {
                    checkboxId = 'ask-form-service-reminder-ca';
                }
                const questionForm: any = document.getElementById('ask-question-form')
                this.noteWithRequestBody = disclaimerHandleCheck(false, questionForm, requestBody, requestBody.zipCode, checkboxId);
                requestBody = this.noteWithRequestBody;
              
            } catch (error) {
                console.error('An error occurred in disclaimerHandleCheck in Refer file:', error);
            }

            // Handle FranchiseWebLocation ID
            // If available, set isLocalized to true as per our requirement.
            const franchiseId = await getFranchiseWebLocationIdDetails(formFields.zipCode?.trim());
            if (franchiseId) {
                requestBody.franchiseWebLocationId = Number(franchiseId);
                requestBody.isLocalized = true;
            }

            startLoader();
            contactUsPostCallWrapper(apiConfig.CONTACT_US_SEND, requestBody).then((response: any) => {
                    stopLoader();
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'success'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                    storeBookingApiPayload(requestBody, response);
                    const forms = document.getElementById('ask-question-form');
                    if (forms) {
                        forms.parentElement?.classList.add('hidden');
                    }

                    const cont = document.getElementById('confirmation');
                    if (cont) cont.classList.remove('hidden');
                    insertAfterUrl();
                    if (document.getElementById('whitepaperdoc')) {
                        const url: any = document.getElementById('whitepaperdoc');

                        // Create a download link.
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url?.value;
                        a.download = 'downloaded.pdf'; // You can set the desired filename here.
                        a.target = "_blank"
                        document.body.appendChild(a);
                        a.click();
                    }
                })
                .catch((err) => {
                    stopLoader();
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'failure'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                    const forms = document.getElementById('ask-question-form');
                    if (forms) {
                        forms.parentElement?.classList.add('hidden');
                    }

                    const cont = document.getElementById('failure');
                    if (cont) cont.classList.remove('hidden');
                });
        } else {
            // stopLoader()
        }
    }

    private getFormFields(): any {
        const fields = {
            firstName: this.nameInput?.value,
            zipCode: this.zipCodeInput?.value,
            phoneNumber: this.phoneNumberInput?.value,
            email: this.emailInput?.value,
            customerType: this.getSelectedRatio(document.getElementsByName('inline-radio-cust')),
            contactMethod: this.getSelectedRatio(document.getElementsByName('inline-radio-method')),
            note: this.commentTextInput?.value ?? '',
            isSignup: (document.querySelector('input[name="inline-radio-tips"]') as HTMLInputElement)?.checked,
            businessName: this.businessNameTextInput?.value,
            lastName: this.lastInput?.value,
        };
        if (this.lastInput?.value) {
            fields.lastName = this.lastInput?.value;
        }
        return fields;
    }
    private checkForLatestUpdateRadio(): boolean {
        if ((document.getElementById('inline-radio-6') as HTMLInputElement)?.checked) {
            return true;
        }
        return false;
    }

    private getSelectedRatio(node: any): string | null {
        const radioButtons = node;
        for (const radioButton of radioButtons) {
            if ((radioButton as HTMLInputElement).checked) {
                const labelElement = document.querySelector(`[for="${radioButton.id}"]`) as HTMLElement;
                const label = labelElement.innerText;
                return label;
            }
        }
        return null;
    }


    private validateForm(): boolean {
        const formFields = this.getFormFields();
        document.querySelectorAll('.invalid-field').forEach((e) => e.classList.remove('invalid-field'));
        const errors: any = {};

        if (formFields.firstName === '' && this.nameInput?.required) {
            errors['send-name'] = '';
        } else if (formFields.firstName && !REGEX.sendName.test(formFields.firstName)) {
            errors['send-name'] = 'Invalid name format.';
        }

        if (formFields?.lastName === '' && this.lastInput?.required) {
            errors['sendL-name'] = '';
        } else if (formFields?.lastName && !REGEX.sendName.test(formFields?.lastName)) {
            errors['sendL-name'] = 'Invalid Last name format.';
        }

        if (formFields.zipCode === '' && this.zipCodeInput?.required) {
            errors['send-zip'] = '';
        } else if (formFields.zipCode && !REGEX.sendZip.test(formFields.zipCode?.trim()) || formFields.zipCode === '00000') {
            errors['send-zip'] = 'Invalid zip code format.';
        }

        if (formFields.phoneNumber === '' && this.phoneNumberInput?.required) {
            errors['send-phone'] = '';
        } else if (formFields.phoneNumber && formFields.phoneNumber.length < 14) {
            errors['send-phone'] = 'Invalid phone format.';
        }
        if (this.validateNotes && formFields.note === '') {
            errors['send-note'] = '';
        }

        if (formFields.email === '' && this.emailInput?.required) {
            errors['send-email'] = '';
        } else if (formFields.email && !REGEX.sendEmail.test(formFields.email)) {
            errors['send-email'] = 'Invalid email format.';
        }

        if (!REGEX.sendCity.test(formFields.city)) {
            errors['send-city'] = 'Invalid city format.';
        }

        if (this.validateBusiness && formFields.businessName === '') {
            errors['business-name'] = '';
        } else if (formFields.businessName && !REGEX.matchAny.test(formFields.businessName)) {
            errors['business-name'] = this.errorMessage?.businessErrorName;
        }

        const errorIdChekboxSpan = this.handleCheckboxChange();
        if (errorIdChekboxSpan) {
            errors[errorIdChekboxSpan] = '';
        }

        Object.keys(errors).forEach((fieldId, index) => {
            const field: any = document.getElementById(fieldId);
            const fieldError: any = document.getElementById(`${fieldId}-error-msg`);
            if (field?.parentNode) {
                const errorMessage = errors[fieldId];
                const errorElement = document.createElement('span');
                errorElement.className = 'error-msg';
                errorElement.id = `${fieldId}-error-msg`;
                errorElement.textContent = errorMessage;
                field.classList.add("invalid-field");
                if (fieldError?.classList.contains('hidden'))
                    fieldError.classList.remove('hidden')
            }
            if (index === 0 && field) {
                field.focus();
            }
        });

        return Object.keys(errors).length === 0;
    }
}

const formHandler = new FormHandlerAskQuestion();
